import { render, staticRenderFns } from "./ServerSettings.vue?vue&type=template&id=91a30714&"
import script from "./ServerSettings.vue?vue&type=script&lang=js&"
export * from "./ServerSettings.vue?vue&type=script&lang=js&"
import style0 from "./ServerSettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports